function NavigatorButtons({ children }) {
  return <div className="select-none h-max w-max flex flex-row pm-nav-buttons">{children}</div>;
}

export default NavigatorButtons;
